const STATUSES = [
    "Created",
    "Processing",
    "ReadyForPickup",
    "InTransit",
    "OutForDelivery",
    "Delivered",
    "Delayed",
    "Pending",
    "PaymentCompleted",
    "Returned",
    "Canceled",
    "Generated",
];

export default function OrderTimeline({ status }) {
    const normalizedStatus = (status || "").toLowerCase();

    const currentIndex = STATUSES.findIndex(
        (s) => s.toLowerCase() === normalizedStatus
    );

    const safeIndex = currentIndex === -1 ? 0 : currentIndex;

    return (
        <div className="mt-6">
            <div className="flex items-center overflow-x-auto">
                {STATUSES.map((s, index) => {
                    const isActive = index <= safeIndex;

                    return (
                        <div key={s} className="flex items-center flex-1 min-w-[120px]">
                            <div className="flex flex-col items-center w-full">
                                <div
                                    className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${isActive
                                            ? "bg-green-600 text-white"
                                            : "bg-gray-300 text-gray-700"
                                        }`}
                                >
                                    {index + 1}
                                </div>

                                <p className="text-xs mt-2 text-center">{s}</p>
                            </div>

                            {index < STATUSES.length - 1 && (
                                <div
                                    className={`flex-1 h-1 mx-2 ${index < safeIndex ? "bg-green-600" : "bg-gray-300"
                                        }`}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}